import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import CustomButton from "../../component/CustomButton/CustomButton";
import CustomLoader from "../../component/CustomLoader/CustomLoader";

import api from "../../config/api";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import requestEmployerCodeAction from "../../redux/requestEmployerCode/action";
import InputComp from "../../component/InputComp/InputComp";
import { isNetworkRequestFailedError } from "../../config/helpers";

class RequestEmployerCode extends Component {
  state = {
    error: {},
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;

    setHistory(history);
  }

  handleTextChange = (e) => {
    const payload = {
      [e.target.name]: e.target.value,
    };

    this.props.handleRequestEmployerChange(payload);
  };

  request = async () => {
    try {
      this.setState({ isLoading: true });

      if (this.validate()) throw new Error("Please fill required fields");

      const { user } = this.props;

      const payload = {
        rcNo: this.props.rcNo,
        companyName: this.props.companyName,
        yearIncorp: this.props.yearIncorp,
        contactFullName: this.props.contactFullName,
        contactEmail: this.props.contactEmail,
        contactPhone: this.props.contactPhone,
        tin: this.props.tin,
      };

      const response = await api.requestEmployerPencomEmployerCode(
        payload,
        user.token
      );

      this.props.setAlertMessage({
        type: "success",
        message: response.data.result,
      });
    } catch (e) {
      this.props.setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.request : null,
      });
    }

    this.setState({ isLoading: false });
  };

  validate = () => {
    const error = {};

    if (!this.props.rcNo) error.rcNo = "This field is required";
    if (!this.props.companyName) error.companyName = "This field is required";
    if (!this.props.contactFullName)
      error.contactFullName = "This field is required";
    if (!this.props.contactPhone) error.contactPhone = "This field is required";
    if (!this.props.contactEmail) error.contactEmail = "This field is required";

    this.setState({ error });

    return Object.keys(error).length;
  };

  render() {
    const { error, isLoading } = this.state;
    const {
      rcNo,
      companyName,
      yearinCorp,
      contactFullName,
      contactPhone,
      contactEmail,
      tin,
    } = this.props;

    return (
      <Container>
        <PageHead
          title="REQUEST EMPLOYER CODE"
          containerStyles={{ width: "100%" }}
        />
        <div>
          <InputComp
            type="text"
            value={rcNo}
            placeholder="RCNo*"
            name="rcNo"
            errorMessage={error.rcNo}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={companyName}
            placeholder="Company Name*"
            name="companyName"
            errorMessage={error.companyName}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={yearinCorp}
            placeholder="Year of Incorporation*"
            name="yearinCorp"
            errorMessage={error.yearinCorp}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={contactFullName}
            placeholder="Contact Full Name*"
            name="contactFullName"
            errorMessage={error.contactFullName}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={contactPhone}
            placeholder="Contact Phone*"
            name="contactPhone"
            errorMessage={error.contactPhone}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={contactEmail}
            placeholder="Contact Email*"
            name="contactEmail"
            errorMessage={error.contactEmail}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <InputComp
            type="text"
            value={tin}
            placeholder="Tin*"
            name="tin"
            errorMessage={error.tin}
            containerStyles={{ width: "100%" }}
            onChange={this.handleTextChange}
          />
          <Row className="my-2 justify-content-center">
            <Col className="p-0" sm={5} md={3}>
              <CustomButton
                buttonClasses="btn-block"
                buttonText="Upload"
                onClick={this.request}
              />
            </Col>
          </Row>
        </div>
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.requestEmployerCode,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,

  handleRequestEmployerChange:
    requestEmployerCodeAction.handleRequestEmployerChange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestEmployerCode);
